<div class="card">
    <div class="card-header">
      <h3>Histórico de Planillas</h3>
    </div>
    <div class="card-body">
        <div class="row">
            <h5>Búsqueda</h5>
			<div class="col-sm form-group">
				<label for="contract" class="form-label">Por contrato</label>
				<select name="contract" (change)="getNumberEmployees()" [(ngModel)]="paymentPeriod" id="contract" class="form-select">
					<option value="0">Diario</option>
					<option value="1">Semanal</option>
					<option value="2">Catorcenal</option>
					<option value="3">Quincenal</option>
					<option value="4">Mensual</option>
				</select>
				<p class="form-text"><i tooltip="Personal contratado" class="fa fa-user"></i>{{numberOfEmployees}}</p>
			</div>
			<div class="col-sm form-group">
                <label for="year" class="form-label">Año</label>
                <input type="number" name="year" id="year" [(ngModel)]="year"
                       class="form-control" min="1900" max="2100" step="1" />
            </div>    
            <div class="col d-flex align-items-center">
                <button class="btn btn-success w-100" (click)="searchGeneratedPayrolls()">
                    <i class="fa fa-search"></i> Buscar
                </button>
            </div>          
		</div>
        <h5>Filtros</h5>
        <!-- Filtros -->
        <div class="row mb-3">
            <div class="col">
            <label class="form-label">Buscar</label>
            <input type="text" class="form-control" [(ngModel)]="searchText" placeholder="Encabezado..." />
            </div>
            <div class="col">
            <label class="form-label">Fecha Inicio</label>
            <input class="form-control" type="date" [(ngModel)]="startDate" />
            </div>
            <div class="col">
            <label class="form-label">Fecha Final</label>
            <input class="form-control" type="date" [(ngModel)]="endDate" />
            </div>
            <div class="col d-flex align-items-end">
            <button class="btn btn-primary w-100" (click)="filterPayrolls()">
                <i class="fa fa-search"></i> Filtrar
            </button>
            </div>
        </div>
    
        <!-- Tabla Principal -->
        <div class="table-responsive">
            <table class="table table-hover table-bordered">
            <thead class="table-light">
                <tr>
                <th>Encabezado</th>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Total</th>
                <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let payroll of paginationPayrolls.filter">
                <tr>
                    <td>{{ payroll.header }}</td>
                    <td>{{ payroll.date | date: 'yyyy/MM/dd' }}</td>
                    <td>{{ payroll.status }}</td>
                    <td>{{ payroll.total | currency:'Q' }}</td>
                    <td class="text-center">
                        <button class="btn btn-outline-info" (click)="showPayrollDetail(payroll)">
                          <i class="fa fa-eye"></i>
                        </button>
                      </td>                                           
                </tr>
                <!-- Detalle Expandido -->
                <!-- <tr *ngIf="expanded[payroll.id]">
                    <td colspan="5">
                    <div *ngFor="let position of payroll.summary">
                        <h6 class="mt-3 text-primary">🧾 Puesto: {{ position.positionName }} - Total: {{ position.total | currency:'Q' }}</h6>
                        <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                            <th>Empleado</th>
                            <th>Monto</th>
                            <th>Descripción</th>
                            <th>Tipo de Pago</th>
                            <th>Fecha</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let person of position.personal">
                            <ng-container *ngFor="let payment of person.payments">
                                <tr>
                                <td>{{ person.employeeName }}</td>
                                <td>{{ payment.amount | currency:'Q' }}</td>
                                <td>{{ payment.description }}</td>
                                <td>{{ payment.paymentType }}</td>
                                <td>{{ payment.paymentDate | date:'yyyy/MM/dd' }}</td>
                                </tr>
                            </ng-container>
                            </ng-container>
                        </tbody>
                        </table>
                    </div>
                    </td>
                </tr> -->
                </ng-container>
    
                <tr *ngIf="paginationPayrolls.filter.length === 0">
                <td colspan="5" class="text-center text-muted">
                    <i class="fa fa-circle-info"></i> No se encontraron planillas.
                </td>
                </tr>
            </tbody>
            </table>
        </div>
        <app-pagination-custom [elements]="paginationPayrolls"></app-pagination-custom>

        <app-simple-modal
        *ngIf="payrollSelected"
        [title]="'Detalle de planilla'"
        (close)="payrollSelected = null"
        [max]="90"
        [requiredFields]="false">
        <div fields>
          <div *ngFor="let position of payrollSelected.summary">
            <h6 class="mt-3 text-primary">
              🧾 Puesto: {{ position.positionName }} - Total: {{ position.total | currency: 'Q' }}
            </h6>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Empleado</th>
                  <th>Total del Empleado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let person of position.personal">
                  <tr>
                    <td>{{ person.employeeName }}</td>
                    <td>{{ person.total | currency: 'Q' }}</td>
                    <td>
                      <button class="btn btn-sm btn-link" (click)="person.expanded = !person.expanded">
                        {{ person.expanded ? 'Ocultar detalles' : 'Ver pagos' }}
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="person.expanded">
                    <td colspan="3">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th>Monto</th>
                            <th>Descripción</th>
                            <th>Tipo de Pago</th>
                            <th>Fecha</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let payment of person.payments">
                            <td>{{ payment.amount | currency: 'Q' }}</td>
                            <td>{{ payment.description }}</td>
                            <td>{{ getPayrollTypeText(payment.paymentType) }}</td>
                            <td>{{ getLastDayOfSelectedPayroll() | date: 'yyyy/MM/dd' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </app-simple-modal>
    </div>
  </div>
  